import { Component } from 'preact'
// eslint-disable-next-line import/no-internal-modules
import { Modal, ModalBody, ModalFooter, ModalHeader } from '@insided/deprecated-preact-components/modal'
// eslint-disable-next-line import/no-internal-modules
import ButtonControl from '@insided/deprecated-preact-components/button-control'
import GenericError from './GenericError'

export interface DeleteSegmentModalProps {
  onClose: () => void
  onDelete: () => void
  showModal: boolean
  showGenericError: boolean
  title: string
}

class DeleteSegmentModal extends Component<DeleteSegmentModalProps> {
  render() {
    const { onClose, onDelete, showModal, title, showGenericError } = this.props

    return (
      <Modal isOpen={showModal} size='medium'>
        <ModalHeader title={`Delete segment ${title}`} onClose={onClose} />
        <ModalBody>
          <p>If you delete a segment, it's gone for good.</p>
          <GenericError show={showGenericError} />
        </ModalBody>
        <ModalFooter>
          <ButtonControl title='Delete' variant='warning' onClick={onDelete} className='qa-delete-custom-view' newStyle size='medium' />
          <ButtonControl title='Cancel' onClick={onClose} newStyle size='medium' />
        </ModalFooter>
      </Modal>
    )
  }
}

export default DeleteSegmentModal
